import styled from '@emotion/styled'

import { zIndex } from '@/styles/theme'

export const NavigationLinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 80px 0;
  background-color: var(--accentFirst);
  contain: content;
`

export const ContentWrapper = styled.div`
  width: 100%;
  padding-bottom: 80px;
  contain: layout;
`

export const DropdownWrapper = styled.div`
  position: relative;
  width: 100%;
`

export const IconWrapper = styled.span<{ isOpen: boolean }>`
  display: inline-flex;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transform: rotate(${props => (props.isOpen ? '180deg' : '0deg')});
  margin-left: 8px;
  width: 14px;
  height: 14px;
  will-change: transform;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`

export const DropdownButton = styled.button<{ isOpen: boolean }>`
  background: none;
  border: none;
  color: white;
  padding: 20px 28px;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 18px;
  transition: all 0.3s ease;
  position: relative;
  width: 100%;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  justify-content: space-between;

  &:focus-visible {
    outline: 2px solid rgba(255, 255, 255, 0.5);
    outline-offset: -2px;
  }
`

export const DropdownContent = styled.div<{ isOpen: boolean }>`
  position: relative;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  overflow: hidden;
  width: 100%;
  max-height: ${props => (props.isOpen ? '1000px' : '0')};
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
  opacity: ${props => (props.isOpen ? '1' : '0')};
  visibility: ${props => (props.isOpen ? 'visible' : 'hidden')};
  contain: content;
`

export const DropdownItem = styled.a`
  padding: 16px 48px;
  font-size: 14px;
  white-space: normal;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.3s ease;
  color: white;
  text-decoration: none;
  display: flex;
  align-items: center;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }

  &:focus-visible {
    outline: 2px solid rgba(255, 255, 255, 0.5);
    background-color: rgba(255, 255, 255, 0.1);
  }
`

export const HighlightedDropdownItem = styled(DropdownItem)`
  font-weight: 700;
  justify-content: space-between;
  padding: 20px 48px;
  display: flex;
  align-items: center;

  svg {
    margin-left: 8px;
  }
`

export const AirportCode = styled.span`
  font-weight: 700;
  margin-right: 20px;
  min-width: 50px;
  display: inline-block;
`

export const NavigationItem = styled.a`
  width: 100%;
  padding: 20px 32px;
  font-size: 18px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  color: white !important;
  text-decoration: none;
  display: block;
  transition: all 0.3s ease;
  position: relative;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }

  &:focus-visible {
    outline: 2px solid rgba(255, 255, 255, 0.5);
    background-color: rgba(255, 255, 255, 0.1);
  }
`

export const LangContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 70px;
  background: #3b8ded;
  padding: 15px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: ${Number(zIndex.header) - 1};
`

export const LoadingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: ${Number(zIndex.header) + 2};
  background-color: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(2px);
`
